import { render, staticRenderFns } from "./videolist.vue?vue&type=template&id=25428aba&scoped=true&"
import script from "./videolist.vue?vue&type=script&lang=js&"
export * from "./videolist.vue?vue&type=script&lang=js&"
import style0 from "./videolist.vue?vue&type=style&index=0&id=25428aba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25428aba",
  null
  
)

export default component.exports